
const handleBold = () => {
    const selected = window.getSelection();
    if (!selected.rangeCount) return;
    const range = selected.getRangeAt(0);
    const formatted = document.createElement("strong");

    //remove selected content
    range.deleteContents();
    //insert text into bold tag
    const inserted = range.insertNode(formatted);

    return inserted;
}

export const formatButtons = [
    {image: 'bold', action: 'bold'},
    {image: 'italic', action: 'italic'},
    {image: 'underline', action: 'underline'},
    {image: 'strikethrough', action: 'strikeThrough'},
    {image: 'superscript', action: 'superscript'},
    {image: 'subscript', action: 'subscript'}
]

